import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  listOutreachSettings,
  OutreachSettings,
} from "#/services/outreachSettings";

export function useOutreachSettingsList() {
  return useQuery<OutreachSettings[]>({
    queryKey: qk.outreachSettingsList(),
    queryFn: ({ signal }) => listOutreachSettings({ signal }),
    staleTime: 30_000,
  });
}

export default useOutreachSettingsList;
